import React, { useState } from "react";
import ShareIcon from '../../assets/icons/share.svg';
import CopyIcon from '../../assets/icons/copy.svg';
import CheckIcon from '../../assets/icons/checked.svg';
import FavouriteTrue from '../../assets/icons/favouritetrue.svg';
import FavouriteFalse from '../../assets/icons/favouritefalse.svg';
import OfficeIcon from '../../assets/icons/OfficeList.svg';
import OtherIcon from '../../assets/icons/OtherList.svg';
import HomeIcon from '../../assets/icons/HomeLIst.svg';
import { EmailShareButton, WhatsappShareButton, FacebookShareButton, TwitterShareButton, EmailIcon, WhatsappIcon, FacebookIcon, TwitterIcon } from "react-share";
import { Address } from '../../API/Address/GetPamCodeSuggessionAsync';
import { AddtoFavouritesAsync } from '../../API/AddressFavourites/AddToFavouritesAsync';
import { RemoveFromFavouritesAsync } from '../../API/AddressFavourites/RemoveFromFavouritesAsync';

interface ViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  addressResponse: Address[];
  t: any;
  copiedField: { type: "pamCode" | "digiPin"; value: string } | null;
  handleCopy: (value: string, type: "pamCode" | "digiPin") => void;
  activeSharePamCode: string | null;
  setActiveSharePamCode: React.Dispatch<React.SetStateAction<string | null>>;
  toggleFavourite: (id?: string) => void;
  formatPamCode: (pamCode: string) => string;
  shareMessage: (address: Address) => string;
  shareBlockCodeMessage: (pinCode: string, blockCode: string, digiPin?: string) => string;
  onFavouriteUpdate?: () => void;
}

const ViewModal: React.FC<ViewModalProps> = ({
  isOpen,
  onClose,
  addressResponse,
  t,
  copiedField,
  handleCopy,
  activeSharePamCode,
  setActiveSharePamCode,
  toggleFavourite,
  formatPamCode,
  shareMessage,
  shareBlockCodeMessage,
  onFavouriteUpdate,
}) => {
  const [localAddresses, setLocalAddresses] = useState<Address[]>(addressResponse);

  React.useEffect(() => {
    setLocalAddresses(addressResponse);
  }, [addressResponse]);

  if (!isOpen) return null;
  console.log("ppp", addressResponse);

  const HeartClick = async (addressId: string, isFavourite: boolean) => {
    // Update local state immediately for UI responsiveness
    setLocalAddresses(prev =>
      prev.map(addr =>
        addr.id === addressId ? { ...addr, isFavourite: !isFavourite } : addr
      )
    );

    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    try {
      const addressIdNum = parseInt(addressId);
      if (!isFavourite) {
        await AddtoFavouritesAsync(addressIdNum, token);
      } else {
        await RemoveFromFavouritesAsync(addressIdNum, token);
      }
      // Call parent callback to refresh data if needed
      if (onFavouriteUpdate) {
        onFavouriteUpdate();
      }
    } catch (error) {
      // Revert on error
      setLocalAddresses(prev =>
        prev.map(addr =>
          addr.id === addressId ? { ...addr, isFavourite: isFavourite } : addr
        )
      );
    }
  };


  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[1000] transition-opacity animate-fade-in">
      <div className="bg-white rounded-3xl shadow-xl w-full max-w-2xl mx-4 sm:mx-0 p-4 sm:p-8 relative transform scale-100 transition-transform animate-scale-in">
        <div className="relative border-b pb-4 mb-2 place-items-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-blue-600 tracking-wide">
            📍 {t("addressDetails")}
          </h2>
        </div>
        <button
          className="absolute top-3 right-3 text-gray-400 hover:text-blue-600 text-4xl font-normal focus:outline-none z-10"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        <div className="px-2 sm:px-4 pt-0 pb-2 sm:pb-4 max-h-80 sm:max-h-96 overflow-y-auto space-y-2 sm:space-y-3">
          {addressResponse.length === 0 ? (
            <div className="text-center text-base sm:text-xl text-gray-500 p-4">
              <p>{t("noAddressData")}</p>
            </div>
          ) : (
            localAddresses.map((address, index) => {
              const pamCode = `${address.pinCode}${address.blockCode}${address.addressCode || ''}`;
              return (
                <div
                  key={address.id || index}
                  className="py-3 sm:py-4 hover:bg-blue-50/40 transition-all cursor-default rounded-xl px-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveSharePamCode(null);
                  }}
                >
                  {address.addressType && (
                    <div className="grid grid-cols-10 mb-2 gap-4 place-content-between">
                      <div className="text-sm sm:text-base col-span-9 font-bold text-gray-700 flex items-center">
                        {address.addressType.toLowerCase() === 'office' && (
                          <>
                            <img src={OfficeIcon} alt="Office Icon" className="w-5 h-5 sm:w-6 sm:h-6 mr-2" />
                            {t("office")}
                          </>
                        )}
                        {address.addressType.toLowerCase() === 'home' && (
                          <>
                            <img src={HomeIcon} alt="Home Icon" className="w-6 h-6 sm:w-8 sm:h-8 mr-2" />
                            {t("home")}
                          </>
                        )}
                        {address.addressType.toLowerCase() === 'other' && (
                          <>
                            <img src={OtherIcon} alt="Other Icon" className="w-6 h-6 sm:w-8 sm:h-8 mr-2" />
                            {t("other")}
                          </>
                        )}
                        {!['office', 'home', 'other'].includes(address.addressType.toLowerCase()) && (
                          <>
                            <img src={OtherIcon} alt="Custom Type Icon" className="w-6 h-6 sm:w-8 sm:h-8 mr-2" />
                            {address.addressType}
                          </>
                        )}
                      </div>
                      <div className="flex items-start justify-end col-span-1 relative">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setActiveSharePamCode((prevPamCode) =>
                              prevPamCode === pamCode ? null : pamCode
                            );
                          }}
                          title="Share"
                          className="p-1 border border-[#D6DFFE] bg-blue-50 rounded-md hover:bg-[#c4d4fc] focus:outline-none flex-shrink-0"
                        >
                          <img src={ShareIcon} alt="Share" className="w-4 h-4" />
                        </button>
                        {address && address.id && address.id !== "null" && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              HeartClick(address.id, address.isFavourite ?? false);
                            }}
                            title="Toggle Favourite"
                            className="p-1 ml-2 border border-[#D6DFFE] bg-blue-50 rounded-md hover:bg-[#c4d4fc] focus:outline-none flex-shrink-0 z-30"
                          >
                            <img src={address.isFavourite ? FavouriteTrue : FavouriteFalse} alt="Favourite" className="w-4 h-4" />
                          </button>
                        )}
                        {activeSharePamCode === pamCode && address && (
                          <div className="absolute z-50 p-2 sm:p-4 mt-8 bg-white shadow-lg rounded-lg border border-gray-200 flex gap-2 sm:gap-4 transform scale-105 right-0">
                            <EmailShareButton
                              url={shareMessage(address)}
                              className="transform transition-transform duration-300 hover:scale-125 hover:shadow-xl"
                            >
                              <EmailIcon size={28} round />
                            </EmailShareButton>
                            <WhatsappShareButton
                              url={shareMessage(address)}
                              className="transform transition-transform duration-300 hover:scale-125 hover:shadow-xl"
                            >
                              <WhatsappIcon size={28} round />
                            </WhatsappShareButton>
                            <FacebookShareButton
                              url={shareMessage(address)}
                              className="transform transition-transform duration-300 hover:scale-125 hover:shadow-xl"
                            >
                              <FacebookIcon size={28} round />
                            </FacebookShareButton>
                            <TwitterShareButton
                              url={shareMessage(address)}
                              className="transform transition-transform duration-300 hover:scale-125 hover:shadow-xl"
                            >
                              <TwitterIcon size={28} round />
                            </TwitterShareButton>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Share button for addresses without addressType */}
                  {!address.addressType && (
                    <div className="flex justify-between items-center mb-2 relative">
                      <div>
                        {/* Warning for addresses without addressCode - only show when array size <= 1 */}
                        {!address.addressCode && addressResponse.length <= 1 && (
                          <p className="text-sm text-yellow-700">{t("noAddressBlock")}</p>
                        )}
                      </div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveSharePamCode((prevPamCode) =>
                            prevPamCode === pamCode ? null : pamCode
                          );
                        }}
                        title="Share"
                        className="p-1 border border-[#D6DFFE] bg-blue-50 rounded-md hover:bg-[#c4d4fc] focus:outline-none flex-shrink-0"
                      >
                        <img src={ShareIcon} alt="Share" className="w-4 h-4" />
                      </button>
                      {activeSharePamCode === pamCode && address && (
                        <div className="absolute z-50 p-2 sm:p-4 mt-8 bg-white shadow-lg rounded-lg border border-gray-200 flex gap-2 sm:gap-4 transform scale-105 right-0">
                          <EmailShareButton
                            url={shareMessage(address)}
                            className="transform transition-transform duration-300 hover:scale-125 hover:shadow-xl"
                          >
                            <EmailIcon size={28} round />
                          </EmailShareButton>
                          <WhatsappShareButton
                            url={shareMessage(address)}
                            className="transform transition-transform duration-300 hover:scale-125 hover:shadow-xl"
                          >
                            <WhatsappIcon size={28} round />
                          </WhatsappShareButton>
                          <FacebookShareButton
                            url={shareMessage(address)}
                            className="transform transition-transform duration-300 hover:scale-125 hover:shadow-xl"
                          >
                            <FacebookIcon size={28} round />
                          </FacebookShareButton>
                          <TwitterShareButton
                            url={shareMessage(address)}
                            className="transform transition-transform duration-300 hover:scale-125 hover:shadow-xl"
                          >
                            <TwitterIcon size={28} round />
                          </TwitterShareButton>
                        </div>
                      )}
                    </div>
                  )}

                  {address.addressLine1 && (
                    <div className="flex flex-col sm:flex-row items-center mb-2">
                      <span className="text-xs sm:text-sm font-semibold text-blue-500">
                        🏠 {t("buildingNumber")}:
                      </span>
                      <span className="ml-0 sm:ml-3 text-blue-700 text-xs sm:text-sm">
                        {address.addressLine1}
                      </span>
                    </div>
                  )}
                  {address.addressLine2 && (
                    <div className="flex flex-col sm:flex-row items-center mb-2">
                      <span className="text-xs sm:text-sm font-semibold text-blue-500">
                        🏡 {t("street")}:
                      </span>
                      <span className="ml-0 sm:ml-3 text-blue-700 text-xs sm:text-sm">
                        {address.addressLine2}
                      </span>
                    </div>
                  )}
                  {address.addressLine3 && (
                    <div className="flex flex-col sm:flex-row items-center mb-2">
                      <span className="text-xs sm:text-sm font-semibold text-blue-500">
                        🏢 {t("city")}:
                      </span>
                      <span className="ml-0 sm:ml-3 text-blue-700 text-xs sm:text-sm">
                        {address.addressLine3}
                      </span>
                    </div>
                  )}
                  <div className="flex items-center gap-2 w-full mb-1">
                    <label htmlFor="pamCode" className="text-sm font-medium whitespace-nowrap w-24">
                      {t("pamCode")}:
                    </label>
                    <div className="relative flex-1">
                      <input
                        type="text"
                        className="w-full p-2 pr-10 border rounded-md text-xs sm:text-sm"
                        value={address.addressCode ? formatPamCode(pamCode) : `${address.pinCode}-${address.blockCode}`}
                        readOnly
                      />
                      <button
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-blue-500"
                        onClick={() => handleCopy(pamCode, "pamCode")}
                      >
                        {copiedField?.type === "pamCode" && copiedField.value === pamCode ? (
                          <img src={CheckIcon} alt="Copied" className="w-5 h-5 sm:w-6 sm:h-6" />
                        ) : (
                          <img src={CopyIcon} alt="Copy" className="w-5 h-5 sm:w-6 sm:h-6" />
                        )}
                      </button>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full">
                    <label htmlFor="digiPin" className="text-sm font-medium whitespace-nowrap w-24">
                      {t("digiPin")}:
                    </label>
                    <div className="relative flex-1">
                      <input
                        type="text"
                        className="w-full p-2 pr-10 border rounded-md text-xs sm:text-sm"
                        value={address.digiPin || "N/A"}
                        readOnly
                      />
                      <button
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-blue-500"
                        onClick={() => handleCopy(address.digiPin || "N/A", "digiPin")}
                        disabled={!address.digiPin}
                      >
                        {copiedField?.type === "digiPin" && copiedField.value === (address.digiPin || "N/A") ? (
                          <img src={CheckIcon} alt="Copied" className="w-5 h-5 sm:w-6 sm:h-6" />
                        ) : (
                          <img src={CopyIcon} alt="Copy" className="w-5 h-5 sm:w-6 sm:h-6" />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
        <div className="flex justify-end pt-2 sm:pt-4 border-t">
          <button
            onClick={onClose}
            className="px-4 sm:px-6 py-2 sm:py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 transition-all"
          >
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewModal;
